<template>
  <transition name="fade">
    <div v-if="visible" class="scroll-top" @click="scrollToTop()">
      <Icon class="scroll-top__icon">{{ wideArrowTopMedium }}</Icon>
    </div>
  </transition>
</template>

<script>
import Icon from '@/components/icon.vue';
import { wideArrowTopMedium } from '@/assets/icons';

export default {
  name: 'ScrollTop',

  components: {
    Icon,
  },

  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      wideArrowTopMedium,
    };
  },

  methods: {
    scrollToTop() {
      this.$emit('scroll-top');
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-top {
  transition: 0.3s ease;
  z-index: 9999;
  cursor: pointer;
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 30px;
  height: 30px;
  background: #2A5A918A;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    transform: scale(1.1);
    background: #2A5A91;
  }
  &__icon {
    color: white;
    height: 20px;
    margin-top: 8px;
  }
}
</style>
